(function($) {

	$.fn.toggleAria = function(e) {
		const i = "aria-" + e;

		return $(this)[0].hasAttribute(i) || console.log("Element has no " + i + " in the first place, adding it, setting it to true."), this.attr(i, function(t, e) {
			return "true" === e ? "false" : "true";
		}), this;
	};

	$.fn.toggleData = function(e) {
		const i = "data-" + e;

		return $(this)[0].hasAttribute(i) || console.log("Element has no " + i + " in the first place, adding it, setting it to true."), this.attr(i, function(t, e) {
			return "true" === e ? "false" : "true";
		}), this;
	};

	function visible(element) {
		return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function() {
			return $.css(this, 'visibility') === 'hidden';
		}).length;
	};

	function focusable(element, isTabIndexNotNaN) {
		var map, mapName, img, nodeName = element.nodeName.toLowerCase();
		if ('area' === nodeName) {
			map = element.parentNode;
			mapName = map.name;
			if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
				return false;
			}
			img = $('img[usemap=#' + mapName + ']')[0];
			return !!img && visible(img);
		}
		return (/input|select|textarea|button|object/.test(nodeName) ?
			!element.disabled :
			'a' === nodeName ?
			element.href || isTabIndexNotNaN :
			isTabIndexNotNaN) &&
		visible(element);
	};

	$.extend($.expr[':'], {
		focusable: function(element) {
			return focusable(element, !isNaN($.attr(element, 'tabindex')));
		}
	});

	function isMobile() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}

	function createCookie(name, value, days) {
		let expires = '';

		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toGMTString();
		}

		document.cookie = name + "=" + value + expires + "; path=/";
	};

	function readCookie(name) {
		const nameEQ = name + "=";
		const ca = document.cookie.split(';');

		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}
			if (c.indexOf(nameEQ) === 0) {
				return c.substring(nameEQ.length, c.length);
			}
		}

		return null;
	};

	function eraseCookie(name) {
		createCookie(name, "", -1);
	};

	function measureScrollbar() {
		const scrollDiv = document.createElement('div');
		scrollDiv.className = 'menu-scrollbar-measure';

		$('body').append(scrollDiv);

		const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

		scrollDiv.remove();

		return scrollbarWidth;
	};

	function setScrollbar() {
		const scrollbarWidth = measureScrollbar();

		$('body, .scrollbar-padding').each(function(){
			const $this = $(this);
			const elPad = parseInt(($this.css('padding-right') || 0), 10);
			const originalElPad = $this[0].style.paddingRight || '';

			$this.css('padding-right', elPad + scrollbarWidth).attr('data-padding', originalElPad);

			if ($this.is('body')) {
				$this.addClass('no-scrolling');
			}
		});
	};

	function resetScrollbar() {
		$('body, .scrollbar-padding').each(function(){
			const $this = $(this);

			$this.css('padding-right', $this.attr('data-padding'));

			if ($this.is('body')) {
				$this.removeClass('no-scrolling');
			}
		});
	};

	function addHTMLClass() {
		$('html').addClass('html-loaded');
	}

	function contrastCookie() {
		const $body 			= $('body');
		const $styleSwitcher 	= $('.style-switcher');

		const highContrastOn 	= 'Switch to standard color contrast version of the website';
		const highContrastOff 	= 'Switch to high color contrast version of the website';

		let highContrast 		= readCookie('contrast');

		if (highContrast === 'true') {
			$body.addClass('contrastHigh');
			$styleSwitcher.attr('title', highContrastOn).attr('aria-label', highContrastOn);
		}

		$('.style-switcher').on('click', function(event){
			highContrast = readCookie('contrast');
			const id = $(this).attr('aria-describedby');
			const message = highContrast === 'true' ? highContrastOff : highContrastOn;
			const cookieVal = highContrast === 'true' ? 'false' : 'true';

			$body.toggleClass('contrastHigh');
			$styleSwitcher.attr('data-original-title', message).attr('aria-label', message);
			$('#' + id + ' .tooltip-inner').text(message);

			createCookie('contrast', cookieVal, 30);
		});
	}

	function setCSSVars() {
		const headerHeight 		= Math.round($('.site-header').outerHeight()) + 'px';
		const mobileCTAHeight 	= Math.round($('.call-to-action-mobile').outerHeight()) + 'px';
		const appHeight 		= Math.round(window.innerHeight) + 'px';
		const appWidth 			= Math.round(document.body.clientWidth) + 'px';

		document.documentElement.style.setProperty('--fixed-header-height', headerHeight);
		document.documentElement.style.setProperty('--mobile-cta-height', mobileCTAHeight);
		document.documentElement.style.setProperty('--app-height', appHeight);
		document.documentElement.style.setProperty('--app-width', appWidth);

		$('body').addClass('css-vars-set');
	}

	function headerMenu() {
		let menuOn = false;

		$('.navbar-toggler').click(function(e) {
			e.preventDefault();

			const $this = $(this);

			$this.toggleClass('active');
			$this.toggleAria('expanded');

			$('body').toggleClass('modal-open').toggleClass('menu-open');

			if(menuOn) {
				resetScrollbar();
			} else {
				setScrollbar();
			}

			menuOn = !menuOn;			
		});

		$('.site-header a').first().keydown(function(e) {
			if (e.keyCode === 9 && e.shiftKey && menuOn == true) {
				e.preventDefault();

				$('.overlay a').last().focus();
			}
		});

		$('.overlay a').last().keydown(function(e) {
			if (e.keyCode === 9 && !e.shiftKey) {
				e.preventDefault();

				$('.site-header a').first().focus();
			}
		});

		let last_known_scroll_position = 0;
		let ticking = false;

		window.addEventListener('scroll', function(e) {
			last_known_scroll_position = window.scrollY;

			if (!ticking) {
				window.requestAnimationFrame(function() {
					if (last_known_scroll_position > 30) {
						$('body').addClass('bg-menu');
					} else {
						$('body').removeClass('bg-menu');
					}
					ticking = false;
				});

				ticking = true;
			}
		});
	}

	function skipNav() {
		$('.btn-skip-nav').click(function(e){
			e.preventDefault();

			const $menu 				= $(this).next('nav');
			const $focusables 			= $(':focusable');
			const index 				= $focusables.index($menu.find(':focusable').last());
			const $nextFocusableItem 	= $focusables.eq(index + 1);

			if ($nextFocusableItem.length > 0) {
				$nextFocusableItem.focus();
			}
			else {
				$focusables.eq(0).focus();
			}
		});
	};

	function initializeBxSlider() {
		if (typeof $.fn.bxSlider == 'undefined') return;

		const windowWidth = window.innerWidth;

		$('.bxslider--carousel-image-with-text').bxSlider({
			mode: 			'fade',
			auto: 			true,
			autoControls: 	true,
			autoHover: 		true,
			name: 			'slide',
			touchEnabled: 	false,
		});

		$('#testimonials-slider').bxSlider({
			nextText: 		'<i class="fas fa-chevron-right"></i>',
			prevText: 		'<i class="fas fa-chevron-left"></i>',
			startText: 		'<i class="fas fa-play"></i>',
			stopText: 		'<i class="fas fa-pause"></i>',
			auto: 			true,
			autoControls: 	true,
			autoHover: 		true,
			name: 			'review',
			touchEnabled: 	false,
		});

		$('.flc-testimonials--carousel-with-image').bxSlider({
			auto: 			false,
			name: 			'review',
			touchEnabled: 	false,
			pager: 			false,
			mode: 			'fade'
		});

		$('.flc-testimonials--carousel').each(function(){
			const $this 		= $(this);
			const columns 		= $this.data('columns');
			const slideWidth 	= windowWidth <= 575 ? 575 : 1110 / columns;

			$this.bxSlider({
				auto: 			false,
				autoControls: 	false,
				pager: 			false,
				minSlides: 		1,
				maxSlides: 		columns,
				moveSlides: 	1,
				slideWidth: 	slideWidth,
				shrinkItems: 	true,
				name: 			'testimonial',
				controlsPrepend: false,
				touchEnabled: 	false,
				adaptiveHeight: true,
				nextText: 		'<i class="fas fa-arrow-right"></i>',
				prevText: 		'<i class="fas fa-arrow-left"></i>',
				onSliderLoad: function(){
					const $self = $(this);
					const $wrapper = $this.closest('.bx-wrapper');

					$self.find('.bx-clone').each(function(index){
						const testimonyContent = $(this).find('.testimonials-body');

						testimonyContent.attr('id', testimonyContent.attr('id') + '-clone-' + index);
					})

					$this.find('.more-carousel').shorten({
						'showChars': 160
					});

					setTimeout(function(){
						$this.redrawSlider();
					}, 1);

					if($wrapper.find('.bx-controls').hasClass('bx-has-pager')) {
						$wrapper.addClass('bx-wrapper-has-pager')
					}

					if($wrapper.find('.bx-controls').hasClass('bx-has-controls-auto')) {
						$wrapper.addClass('bx-wrapper-has-controls-auto')
					}
				}
			});

			$this.on('click', '.morelink', function(){
				setTimeout(function(){
					$this.redrawSlider();
				}, 1);
			});
		});

		$('.carousel-logo').each(function(){
			const $this = $(this);

			$this.bxSlider({
				auto: 			true,
				autoControls: 	true,
				minSlides: 		2,
				maxSlides: 		8,
				moveSlides: 	1,
				slideWidth: 	$this.data('width'),
				name: 			'logo',
				pager: 			false,
				touchEnabled: 	false,
				shrinkItems: 	true
			});
		})
	};

	function initializeColorbox() {
		$('.flc-gallery').each(function() {
			const $this = $(this);

			$this.find('a').colorbox({
				rel: 		$this,
				maxWidth: 	'100%',
				maxHeight: 	'100%',
				transition: 'elastic',
				previous: 	'<i class="fas fa-chevron-left" aria-label="Previous photo"></i>',
				next: 		'<i class="fas fa-chevron-right" aria-label="Next photo"></i>',
				close: 		'<i class="fas fa-times" aria-label="Close gallery"></i>',
				title: function(){
					const $this = $(this);
					const colorboxDescription = $(this).attr('data-description');
					const colorboxCaption = $(this).attr('data-caption');

					return colorboxDescription ? colorboxDescription : colorboxCaption;
				}
			});
		});

		$(document).bind('cbox_open', setScrollbar);
		$(document).bind('cbox_closed', resetScrollbar);
	};

	function showSearch() {
		$('.btn-search').click(function() {
			$(this).toggleAria('expanded');
			$('#search-box').slideToggle();
		});
	};

	function searchFormValidate() {
		$('.searchform').submit(function(e) {
			const $this = $(this);

			if ($this.find('.form-control').val() !== '') return e;
			e.preventDefault();

			if ($(this).hasClass('validated')) return;

			$(this).addClass('validated')
				.append('<div class="wpcf7-response-output wpcf7-display-none wpcf7-validation-errors" role="alert" style="display: block;">Search box can not be empty.</div>');
		});
	};

	function tabsKeyboardNav() {
		$('[role="tab"]').keydown(function(e) {
			var $this = $(this),
			allTabs = $this.closest('[role="tablist"]').find('[role="tab"]'),
			allTabsEq = allTabs.length,
			currentIndex = allTabs.index($this),
			nextTab = allTabs.eq(currentIndex + 1),
			prevTab = allTabs.eq(currentIndex - 1),
			target;

			if (e.keyCode == 39) {
				if (currentIndex + 1 == allTabsEq) return;

				target = nextTab;
			}

			if (e.keyCode == 37) {
				if (currentIndex == 0) return;

				target = prevTab;
			}

			if (target) target.tab('show').focus();
		});
	};

	function collaspeKeyboardNav() {
		var delay = false,
		buttons = [35, 36, 38, 40];

		$('[data-toggle="collapse"]').keydown(function(e) {

			if ($.inArray(e.keyCode, buttons) >= 0) {
				e.preventDefault();
			}

			if (delay === true) {
				return;
			}

			var $this = $(this),
			allTabs = $this.closest('.flc-faq').find('[data-toggle="collapse"]'),
			allTabsEq = allTabs.length,
			currentIndex = allTabs.index($this),
			nextTab = allTabs.eq(currentIndex + 1),
			prevTab = allTabs.eq(currentIndex - 1),
			target;


			if (e.keyCode == 40) {
				target = currentIndex + 1 == allTabsEq ? allTabs.eq(0) : nextTab;
			}
			if (e.keyCode == 38) {
				target = currentIndex == 0 ? allTabs.eq(allTabsEq - 1) : prevTab;
			}
			if (e.keyCode == 36 && currentIndex !== 0) {
				target = allTabs.eq(0);
			}
			if (e.keyCode == 35 && currentIndex !== allTabsEq - 1) {
				target = allTabs.eq(allTabsEq - 1);
			}

			if (target) {
				target.click().focus();
			}

			delay = true;

			setTimeout(function() {
				delay = false;
			}, 500);

		})
	};

	function wcagTooltip() {
		let isEsc = false;

		$('[data-toggle="tooltip"]').tooltip({
			delay: {
				'show': 0,
				'hide': 500
			}
		});

		$('[data-toggle="tooltip"]').on('mouseenter mouseleave', function() {
			$(this).toggleClass('hovered');
		});

		$('[data-toggle="tooltip"]').on('show.bs.tooltip', function() {
			$('[data-toggle="tooltip"]').tooltip('hide');
		});

		$('[data-toggle="tooltip"]').on('hide.bs.tooltip', function() {
			const tooltip 			= $('.tooltip');
			const currentTooltip 	= $(this);

			if ($('.tooltip:hover').length > 0 && isEsc === false) {
				tooltip.on('mouseleave', function(e) {
					setTimeout(function() {
						if (tooltip.length > 0 && $('.tooltip:hover').length <= 0 && !currentTooltip.hasClass('hovered')) {
							currentTooltip.tooltip('hide');
						}
					}, 501);
				});

				return false;
			}
		});

		$(document).on('keydown', function(e) {
			if (e.keyCode === 27) {
				isEsc = true;
				$('[data-toggle="tooltip"]').tooltip('hide');
			}
		});

		$(document).on('keyup', function(e) {
			if (e.keyCode === 27) {
				isEsc = false;
			}
		});
	};

	function setElCoords(el, highlighter) {
		const coords = {
			width: 	el.outerWidth(),
			height: el.outerHeight(),
			left: 	el.position().left,
			top: 	el.position().top
		};

		highlighter.css({
			'left': 	coords.left,
			'top': 		coords.top,
			'height': 	coords.height,
			'width': 	coords.width
		});
	};

	function menuHighlight() {
		const menu = $('nav.navbar');
		const elMenuHighlight = $('<div class="navbar-highlight"></div>');
		const mainItem = $('.navbar .nav > li.current_page_parent > a').length > 0 ? $('.navbar .nav > li.current_page_parent > a') : $('.navbar .nav > li.current-menu-item > a');
		const highlightedItem = mainItem.length > 0 ? mainItem : $('.navbar .nav > li:first-of-type > a');

		menu.addClass('highlight-active').append(elMenuHighlight);

		setElCoords(highlightedItem.parent(), elMenuHighlight);

		$('.navbar .nav > li > a').on('mouseenter focus', function() {
			setElCoords($(this).parent(), elMenuHighlight);
		});

		$('.navbar .nav').on('mouseleave focusout', function() {
			setElCoords(highlightedItem.parent(), elMenuHighlight);
		});
	};

	function WOWAfterReveal (el) {
		el.classList.add('animation-finished');
	}

	function enableAnimations() {
		if (typeof WOW == 'undefined') return;

		const wow = new WOW({
			boxClass:   	'wow',
			animateClass: 	'animated',
			offset:     	0,
			mobile:     	false,
			live:     		true,
			callback:   	WOWAfterReveal
		});

		wow.init();
	}

	function FLCPageBuilder() {
		$('.flc-text-image-header').each(function(){
			$(this).closest('.flc-section').addClass('flc-section--has-image-header');
		})
	}

	function tabsBg(){
		$('.flc-tabs-horizontal__links a').click(function(){
			const $this = $(this);
			const bgIndex = $this.data('bg');
			const $backgrounds = $this.closest('.flc-tabs-horizontal').find('.flc-tabs-horizontal__bg-item');

			$backgrounds.animate({ 'opacity': "0" }, 200);
			$backgrounds.eq(bgIndex).stop().animate({ 'opacity': "1" }, 200);
		})
	}

	function toggleVideo(video) {
		if (video.paused) {
			video.play(); 
		}
		else {
			video.pause();
		}
	}

	function FLCVideo() {
		$('.btn-video').click(function(){
			const $this = $(this);
			const video = $this.closest('.flc-video').find('video')[0];
			const isVideoPlaying = $this.attr('data-video-playing') == 'true';
			const icon = isVideoPlaying ? '<i class="fas fa-play" aria-hidden="true"></i>' : '<i class="fas fa-pause" aria-hidden="true"></i>';
			const label = isVideoPlaying ? 'play video' : 'pause video';

			toggleVideo(video);
			$this.html(icon)
				.toggleData('video-playing')
				.attr('aria-label', label);
		})
	}

	function addMobileClass() {
		if (isMobile()) {
			$('body').addClass('body--mobile');
		}
		else {
			$('body').addClass('body--desktop');
		}
	}

	function showAlertModal() {
		if (flc_vars.modalActive !== '1') {
			return;
		}

		const today = new Date();

		if (flc_vars.modalStartDate !== '' && today < new Date(flc_vars.modalStartDate)) {
			return;
		}

		if (flc_vars.modalEndDate !== '' && today > new Date(flc_vars.modalEndDate)) {
			return;
		}

		const $alertModal = $(`#${flc_vars.modalID}`);
		const modalCookie = 'modal-' + flc_vars.modalID;

		if (readCookie(modalCookie) !== 'false') {
			$alertModal.modal('toggle');
		} 

		$alertModal.on('hide.bs.modal', function (e) {
			createCookie(modalCookie, 'false', 30);
		})
	}

	function showAlertBottom() {
		if (flc_vars.alertBottomActive !== '1') {
			return;
		}

		const today = new Date();

		if (flc_vars.alertBottomStartDate !== '' && today < new Date(flc_vars.alertBottomStartDate)) {
			return;
		}

		if (flc_vars.alertBottomEndDate !== '' && today > new Date(flc_vars.alertBottomEndDate)) {
			return;
		}

		$('.alert-fixed-bottom').show();
	}

	function countdownBoxes() {
		$('.countdown-box').each(function(){
			const $this 			= $(this);
			const daysMultiplier 	= (60 * 60 * 24);
			const timestamp 		= $this.data('timestamp');

			let countdownInterval = setInterval(function() {
				const now 		= new Date().getTime() / 1000;
				const distance 	= timestamp - now;

				const days 		= Math.floor(distance / daysMultiplier);
				const hours 	= Math.floor((distance % daysMultiplier) / (60 * 60));
				const minutes 	= Math.floor((distance % (60 * 60)) / 60);
				const seconds 	= Math.floor(distance % 60);

				$this.find('.days').text(days);
				$this.find('.hours').text(hours);
				$this.find('.minutes').text(minutes);
				$this.find('.seconds').text(seconds);

				if (distance < 0) {
					clearInterval(countdownInterval);
				}
			}, 1000);

			setTimeout(function(){
				$this.show();
			}, 1001);
		})
	}

	function scrollingImages() {
		const $scrollingImages = $('.flc-logos-rotating__overlay--animate');

		if ($scrollingImages.length < 1) {
			return;
		}

		setTimeout(function(){
			const animationSpeed = 10;

			$scrollingImages.each(function(){
				const $this 	= $(this);
				const width 	= $this[0].scrollWidth;
				const $section 	= $this.closest('.flc-logos-rotating');

				if (width < $section.outerWidth()) {
					return;
				}

				const duration = width / 1000 * animationSpeed + 's';
				const margin = width * -1 + 'px';

				$this[0].style.setProperty('--animation-duration', duration);
				$this[0].style.setProperty('--animation-distance', margin);

				$section.addClass('active');
			});

			$('.flc-logos-rotating__btn').click(function(){
				const $this = $(this);
				const $slider = $this.closest('.flc-logos-rotating');
				const currentText = $this.attr('aria-label');
				const newText = $this.attr('data-aria');
				const currentIcon = $this.attr('data-orig-icon');
				const newIcon = $this.attr('data-icon');

				$slider.toggleClass('flc-logos-rotating--disabled');
				$this.attr({
					'aria-label': newText,
					'data-aria': currentText,
					'data-orig-icon': newIcon,
					'data-icon': currentIcon,
				}).html(newIcon);
			})
		}, 500);
	}

	function addSVGs() {
		const svgs = {
			'play': '<svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="40.5" cy="40.0952" r="40" fill="white"/><path d="M50.1761 38.9937C51.3871 39.7358 51.3871 41.4937 50.1761 42.2358L36.4261 50.3608C35.1761 51.103 33.6136 50.2046 33.6136 48.7202V32.4702C33.6136 30.8687 35.2933 30.2046 36.4261 30.8687L50.1761 38.9937Z" fill="black" class="fill-hover-primary"/></svg>',
		};

		$('.btn-play').each(function(){
			const $this = $(this);
			let content = svgs.play;

			if ($this.hasClass('btn-play--text')) {
				content += '<span class="watch-video lead text-14 text-sm-18 pb-2">Watch Video</span>'
			}

			$this.append('<span class="play-icon d-flex flex-column align-items-center row-gutter-1 bg-wcag-primary">' + content + '</span>').addClass('svg-hover-trigger btn-clear');
		})
	}

	function videoModal() {
		const $popup = $('#video-list-modal');

		$('.open-video').each(function(){
			const $this = $(this);
			const videoID 	= $this.data('videoId');
			const title 	= $this.data('title');
			const videoUrl 	= `https://www.youtube.com/embed/${videoID}?rel=0&autoplay=1`;

			$this.attr('aria-label', 'Click here to open video titled ' + title);

			$this.click(function(){
				$popup.find('iframe').attr({
					'src': videoUrl,
					'title': title
				});

				$popup.modal();
			})
		})

		$popup.on('hide.bs.modal', function(){
			$popup.find('iframe').attr('src', '');
		})
	}

	function galleryPopup() {
		const $modal = $('#gallery-modal');

		if ($modal.length < 1) {
			return;
		}

		let mainSlider;

		function initializeFullBxSlider(el) {
			if ( $modal.find('#galleryFull img').first().outerHeight() == 0 ) {
				setTimeout(function(){
					initializeFullBxSlider();
				}, 300);
			}
			else {
				mainSlider = $modal.find('#galleryFull .slider').bxSlider({
					mode: 			'fade',
					auto: 			false,
					name: 			'slide',
					touchEnabled: 	false,
					pager: 			false,
					controls: 		false,
					adaptiveHeight: true
				});
			}
		}

		function initializeThumbBxSlider() {
			if ( $modal.find('#galleryThumbs img').first().outerHeight() == 0 ) {
				setTimeout(function(){
					initializeThumbBxSlider();
				}, 300);
			}
			else {
				$modal.find('#galleryThumbs .slider').bxSlider({
					auto: 			false,
					minSlides: 		4,
					maxSlides: 		4,
					moveSlides: 	1,
					slideWidth: 	200,
					slideMargin: 	7,
					name: 			'thumbnails',
					pager: 			false,
					touchEnabled: 	false,
					shrinkItems: 	true,
					nextText: 		'<i class="fas fa-chevron-right"></i>',
					prevText: 		'<i class="fas fa-chevron-left"></i>',
				});
			}
		}

		$('.gallery-category__modal-btn').click(function(){
			const $this = $(this);
			
			$.each($this.data(), function(key, value){
				$modal.find('#' + key).html(value);
			});

			initializeFullBxSlider();
			$modal.find('#galleryThumbs').removeClass('gallery-thumbnails--no-slider d-none');

			const $galleryThumbBtns = $modal.find('#galleryThumbs button');	

			if ($galleryThumbBtns.length < 2) {
				$modal.find('#galleryThumbs').addClass('d-none');
			}
			else if ($galleryThumbBtns.length < 5) {
				$modal.find('#galleryThumbs').addClass('gallery-thumbnails--no-slider');
			}
			else {
				initializeThumbBxSlider();
			}

			setTimeout(function(){
				$modal.find('.modal-body :focusable').last().keydown(function(e) {
					if (e.keyCode === 9 && !e.shiftKey) {
						e.preventDefault();

						$modal.find('.btn-close').focus();
					}
				});
			}, 1000);
		})

		$modal.find('#galleryThumbs').on('click', '.gallery-thumb', function(){
			const $this = $(this);
			const $container = $this.closest('#galleryThumbs');
			const slideIndex = $this.data('slide');

			mainSlider.goToSlide(slideIndex);

			$container.find('.gallery-thumb').removeClass('active');
			$container.find('[data-slide="' + slideIndex + '"]').addClass('active');
		})

		$modal.find('.btn-close').keydown(function(e) {
			if (e.keyCode === 9 && e.shiftKey) {
				e.preventDefault();

				$modal.find('.modal-body :focusable').last().focus();
			}
		});		
	}

	function gformsAccessibility() {
		$('.gfield--input-type-datedropdown .ginput_container_date').each(function(){
			const $this 	= $(this);
			const id 		= $this.find('select').attr('id');
			const elClass 	= $this.attr('class');
			let label;

			if (elClass.includes('_day')) {
				label = 'Day';
			}
			else if(elClass.includes('_month')) {
				label = 'Month';
			}
			else {
				label = 'Year';
			}

			$this.append(`<label for="${id}" class="label-small mb-0 mt-1">${label}</label>`);
		})
	}

	$(document).ready(function() {
		contrastCookie();
		wcagTooltip();
		gformsAccessibility();
		skipNav();
		collaspeKeyboardNav();
		tabsKeyboardNav();

		addMobileClass();

		headerMenu();
		setCSSVars();

		showSearch();
		searchFormValidate();

		showAlertModal();
		showAlertBottom();

		$(".more").shorten({
			"showChars": 200
		});

		if ($('.navbar-nav').data('smartmenus')) {
			$('.navbar-nav').data('smartmenus').opts.bootstrapHighlightClasses = '';
		}

		initializeBxSlider();
		initializeColorbox();

		FLCPageBuilder();
		tabsBg();
		enableAnimations();
		FLCVideo();

		addSVGs();
		videoModal();
		galleryPopup();
		scrollingImages();

		//countdownBoxes();

		$(window).resize(setCSSVars);

		$(window).on('load', function(){
			addHTMLClass();
		});
	});
})(jQuery);